import { ReactNode } from 'react';
import { View } from 'tamagui';
import { Footer } from '@giffgaff/fe-design-system-ui';
import { WordmarkArtwork } from '@giffgaff/fe-design-system-assets/artwork/Wordmark';
import { Footer as LegacyFooter } from '@fe-toolkit/web-components/ssr';
import { footerLinks } from '@fe-toolkit/utility';
import { FOOTER_SOCIAL_LINKS } from './fallbackChrome.content';
import { FallbackChromeFlags, showsNewChrome } from './fallbackChromeFlags';

// Degraded Footer rendered when the fe_common remote is unavailable: the feds-ui Footer when
// `giffgaff-brand-refresh-2026` is on, as fe-common's CommonFooter does (Black Friday never changes it),
// otherwise the legacy fe-toolkit Footer (see fallbackChromeFlags). The feds-ui categories are its
// packaged defaults. Shared by both the errorLoadRemote registry and the
// FederatedComponentBoundary (layout.tsx) so the degraded UI matches.
//
// From feds-ui 52 it draws the packaged legal row and network note too, as fe-common's CommonFooter
// does when given no host links. The feds-ui terms section stays on (Footer's default): it carries the FCA and Klarna regulatory
// disclaimer, which fe-common's footer prints and no page in this app does. `terms` are the page's
// own, the same CommonFooter gets (layout.tsx), and only the feds-ui Footer shows them.
export default function FallbackFooter({
  terms
}: {
  terms?: ReactNode[];
}) {
  return <FallbackChromeFlags>
      {flags => showsNewChrome(flags) ? <BrandRefreshFooter terms={terms} /> : <LegacyFooter links={footerLinks} small={false} />}
    </FallbackChromeFlags>;
}
const BrandRefreshFooter = ({
  terms
}: {
  terms?: ReactNode[];
}) => <Footer logo={<View aria-label="giffgaff" height="100%" role="img" width="100%">
        <WordmarkArtwork aria-hidden height="100%" width="100%" />
      </View>} social={FOOTER_SOCIAL_LINKS} terms={terms} />;